import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { tokens } from "../../Common/designTokens";

const SecMasterDownloadConfirmModal = ({
  open,
  onProceed,
  onClose,
  loading = false,
  totalElements = 0,
  limit = 10000,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="secmaster-download-confirm-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: tokens.colors.bodyBackgroundColor,
          border: `1px solid ${tokens.colors.bodyBorderColor50}`,
          boxShadow: 24,
          p: 2,
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          id="secmaster-download-confirm-title"
          variant="h6"
          component="h2"
          sx={{ color: tokens.colors.fontColour, mb: 2, textAlign: "center", fontWeight: 700 }}
        >
          Attention
        </Typography>

        <Typography sx={{ color: tokens.colors.fontColour85, mb: 1, textAlign: "center" }}>
          Sec Master currently contains {Number(totalElements).toLocaleString()} records.
        </Typography>
        <Typography sx={{ color: tokens.colors.fontColour85, mb: 1, textAlign: "center" }}>
          Due to export size limitations, only the first {Number(limit).toLocaleString()} records will be
          downloaded.
        </Typography>
        <Typography sx={{ color: tokens.colors.fontColour85, mb: 3, textAlign: "center" }}>
          {/* Please apply filters to narrow the results if you require a complete export. */}
          Do you want to continue?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: tokens.colors.fontColour,
              borderColor: tokens.colors.bodyBorderColor50,
              "&:hover": {
                borderColor: tokens.colors.bodyBorderColor50,
                backgroundColor: tokens.colors.defaultGridHoverColor,
              },
              width: "140px",
              borderRadius: "8px",
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={onProceed}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: tokens.palette.primary,
              "&:hover": { backgroundColor: tokens.palette.primaryA80 },
              width: "140px",
              color: tokens.colors.white,
              borderRadius: "8px",
            }}
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SecMasterDownloadConfirmModal;
